import { Box, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import Carousel from "../../carousel";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useResponsive } from "../../../hooks/mediaQuery";

const StationGalary = ({ data, editUrl, defaultOpen }: { data: any[]; editUrl: string; defaultOpen?: boolean }) => {
    const [open, setOpen] = useState<boolean>(defaultOpen || false);
    const { isXs, isSm, isMd, isLg, isXl } = useResponsive();
    return (
        <div className="bg-white rounded-md">
            <Box sx={{ borderRadius: 1, border: "1px solid #cce4ff" }}>
                <Box
                    className="summary_header"
                    sx={{
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                    onClick={() => setOpen(!open)}
                >
                    <Typography fontWeight="bold">Hình ảnh</Typography>
                    <div className="flex items-center gap-2">
                        <Link
                            to={editUrl}
                            className="flex items-center gap-1 italic text-blue-500 text-sm hover:underline"
                        >
                            <Pencil size={12} />
                            Sửa
                        </Link>
                        <IconButton size="small">
                            <ExpandMoreIcon
                                sx={{
                                    transform: open ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                }}
                            />
                        </IconButton>
                    </div>
                </Box>
                <Collapse in={open}>
                    <Box className="gallery_slider" sx={{ p: isXs ? 0 : 2 }}>
                        <Carousel files={data} />
                    </Box>
                </Collapse>
            </Box>
        </div>
    );
};

export default StationGalary;